import {
  isIPv4CIDR,
  isIPv6CIDR,
} from '@ipfabric/ui-components/IPSubnetInput/helpers/ipAddressValidations';
import { ALLOWED_MASK_SEED_V4, ALLOWED_MASK_SEED_V6 } from './constants';

export const validateCIDRMask = (item: string) => {
  const [, prefix] = item.split('/');
  if (prefix === '') {
    return 'Invalid IP address';
  }
  if (isIPv4CIDR(item) && Number(prefix) < ALLOWED_MASK_SEED_V4) {
    return `Mask must be equal or greater than ${ALLOWED_MASK_SEED_V4}`;
  }
  if (isIPv6CIDR(item) && Number(prefix) < ALLOWED_MASK_SEED_V6) {
    return `Mask must be equal or greater than ${ALLOWED_MASK_SEED_V6}`;
  }
  return '';
};
